import { render } from "./image-block.vue?vue&type=template&id=ebf569ba&scoped=true&ts=true&lang=pug"
import script from "./image-block.vue?vue&type=script&lang=ts"
export * from "./image-block.vue?vue&type=script&lang=ts"

import "./image-block.vue?vue&type=style&index=0&id=ebf569ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebf569ba"]])

export default __exports__